module.exports = __webpack_public_path__ + "img/7763d15.png";